import { createStore } from 'vuex'
import axios from 'axios';
import router from './router';
import VuexPersistence from 'vuex-persist';

let url = window.location.origin;

if (process.env.NODE_ENV == 'development') {
    url = 'http://localhost:8000';
}

const vuexLocal = new VuexPersistence({
    storage: window.localStorage
});

export default new createStore({
    state: {
        sidebar_drawer: true,
        token: localStorage.getItem('token') || '',
        loader: false,
        user: {},
        release_version: null,
        company_name: '',
        primary_color: '#E3EBEC',
        logo: null,
        language: 'en',
        app_url: url + '/api/',
        translations: [],
        panels: {},
        profile_name: null,
        profile_image: null,
    },
    mutations: {
        setSidebarDrawer(state, payload) {
            state.sidebar_drawer = payload;
        },
        auth_success(state, token) {
            state.token = token;
        },
        user(state, user) {
            state.user = user;
            state.profile_name = user.person ? user.person.casual_name : user.email;
            state.profile_image = user.person && user.person.file ? user.person.file.full_path : null;
        },
        logout(state) {
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + state.token;
            axios.post(url + '/api/v2/logout').then(response => {
                console.log(response.data);
            });
            state.token = '';
            state.user = null;
            state.profile_image = null;
            state.profile_name = null;
        },
        setLanguage(state, payload) {
            state.language = payload;
        },
        setPanel(state, payload) {
            state.panels[payload.module_name] = payload.value;
        },
        refreshTranslations(state) {
            axios.get(url + '/api/v2/translations-without-login').then(response => {
                state.translations = response.data;
            });
        },
        setProfileName(state, payload) {
            state.profile_name = payload;
        },
        setProfileImage(state, payload) {
            state.profile_image = payload;
        },
        setReleaseVersion(state, payload) {
            state.release_version = payload;
        },
        setCompanyName(state, payload) {
            state.company_name = payload;
        },
        setPrimaryColor(state, payload) {
            state.primary_color = payload;
        },
        setLogo(state, payload) {
            state.logo = payload;
        },
        setLoader(state, payload) {
            state.loader = payload;
        },
    },
    actions: {
        login({ commit }, auth) {
            return new Promise((resolve, reject) => {
                axios({ url: url + '/api/v2/login', data: auth, method: 'POST' }).then(response => {
                    const token = response.data.token;
                    axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
                    commit('auth_success', token);
                    resolve(response);
                }).catch(err => {
                    localStorage.removeItem('token');
                    reject(err);
                });
            });
        },
        verified({ commit }) {
            return new Promise((resolve) => {
                axios.get(url + '/api/user').then(response => {
                    if(response.data.roles) {
                        response.data.roles.forEach((role) => {
                            if (role.id === 9) {
                                response.data.superuser = true;
                            }
                        });
                    }
                    commit('user', response.data);
                    if (response.data.type === 'employee' || response.data.type === 'contact') {
                        router.push('/portal');
                    }
                    else {
                        if(localStorage.getItem('path')) {
                            router.push(localStorage.getItem('path'));
                        }
                        else {
                            router.push('/');
                        }
                    }
                    resolve(response);
                });
            });
        },
        logout({ commit }) {
            return new Promise((resolve) => {
                commit('logout');
                router.push('/login');
                resolve();
            })
        },
        setLanguage({commit}, data) {
            commit('setLanguage', data);
        },
        refreshTranslations({commit}, data) {
            commit('refreshTranslations', data);
        },
        setPanel({commit}, data) {
            commit('setPanel', data);
        },
        setProfileName({commit}, data) {
            commit('setProfileName', data);
        },
        setProfileImage({commit}, data) {
            commit('setProfileImage', data);
        },
        setSidebarDrawer({commit}, data) {
            commit('setSidebarDrawer', data);
        },
        setReleaseVersion({commit}, data) {
            commit('setReleaseVersion', data);
        },
        setCompanyName({commit}, data) {
            commit('setCompanyName', data);
        },
        setPrimaryColor({commit}, data) {
            commit('setPrimaryColor', data);
        },
        setLogo({commit}, data) {
            commit('setLogo', data);
        },
        setLoader({commit}, data) {
            commit('setLoader', data);
        },
    },
    getters: {
        isLoggedIn: state => !!state.user,
        token: state => state.token,
        appUrl: state => state.app_url,
        getUser: state => state.user,
        getLanguage: state => state.language,
        SidebarDrawer: state => state.sidebar_drawer,
        translationsMap: (state) => {
            let result = new Map();
            state.translations.filter(item => item.language === state.language).forEach((translation) => {
                if (!result.has(translation.key)) {
                    result.set(translation.key, translation.value);
                }
            });
            return result;
        },
        translate: (state, getters) => (payload) => {
            if (getters.translationsMap.has(payload)) {
                return getters.translationsMap.get(payload);
            }
            return payload;
        },
        getPanel: (state) => (payload) => {
            if(state.panels[payload]) {
                return Array.from(state.panels[payload]);
            }
            else {
                return [0];
            }
        },
        profileImage: state => state.profile_image,
        profileName: state => state.profile_name,
        getReleaseVersion: state => state.release_version,
        getCompanyName: state => state.company_name,
        getPrimaryColor: state => state.primary_color,
        getLogo: state => state.logo,
        getLoader: state => state.loader,
    },
    plugins: [vuexLocal.plugin]
})